import React from 'react';
import { Image, View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";
import { FormattedMessage } from 'react-intl';

import HeaderDefault from '../../components/HeaderDefault';

import styles from './styles';

const PaymentMethodTransfer = ({ navigation }) => {
    return (
        <>
            <HeaderDefault title={<FormattedMessage id='paymentMethodTransfer.headerEscolhaForma'/>} />

            <View style={styles.content}>
                <View style={styles.contentList}>
                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate({ name: "SearchUsers", params: { "page":"ConfirmSearchUser" } })}>
                        <Image style={[styles.iconInfo, { width: 28, height: 20 }]} source={require('../../../assets/imgs/search.png')} />
                        <View>
                            <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodTransfer.txtBuscar'/></Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodTransfer.txtTransfiraAtivosOutroUserApp'/></Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("SelectPixKey")}>
                        <Image style={[styles.iconInfo, { width: 28, height: 28 }]} source={require('../../../assets/imgs/pix.png')} />
                        <View>
                            <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodTransfer.txtPix'/></Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodTransfer.txtTransfiraAtravesPix'/></Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("MyBalance")}>
                        <Image style={[styles.iconInfo, { width: 28, height: 23 }]} source={require('../../../assets/bank.png')} />
                        <View>
                            <Text style={styles.titleItemList}><FormattedMessage id='paymentMethodTransfer.txtContaBancaria'/></Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}><FormattedMessage id='paymentMethodTransfer.txtSaqueDiretoEmConta'/></Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />
                </View>
            </View>
        </>
    )
}

export default PaymentMethodTransfer;